import { useEffect } from "react";
import useStateOfFareCalendar from "./useStateOfFareCalendar";
import {
  FARE_CALENDAR_RANGE,
  EXPERIRMENT_HEADERS,
} from "@/constants/common.constants";

export default function useFetchFareCalendar(
  query: string,
  isRoundTrip = false,
  state: ReturnType<typeof useStateOfFareCalendar>,
) {
  const {
    fareCalendar,
    filtersQuery,
    pricingFilters,
    isCompleted,
    isRestoringPreservedFilters,
  } = state;
  function handleFareCalendarFetch() {
    if (isRestoringPreservedFilters) {
      return;
    }

    fareCalendar.fetch({
      query,
      range: FARE_CALENDAR_RANGE,
      filtersQuery,
      ...pricingFilters,
      headers: {
        ...(isRoundTrip && {
          [EXPERIRMENT_HEADERS.MULTI_PNR_FARE_CALENDAR_HEADER]: true,
        }),
      },
    });
  }

  // Effect - Loading Fetch
  useEffect(() => {
    if (query) {
      try {
        handleFareCalendarFetch();
      } catch (e) {
        console.error("FARE_CALENDAR_CLIENT_LOADING_FETCH_ERROR");
      }
    }
  }, [query, isRoundTrip]);

  useEffect(() => {
    if (!fareCalendar.isLoading && isCompleted) {
      try {
        handleFareCalendarFetch();
      } catch (e) {
        console.error("FARE_CALENDAR_CLIENT_LOADING_FETCH_ERROR");
      }
    }
  }, [filtersQuery, fareCalendar, isCompleted, isRoundTrip]);
}
